import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import {
  PreviewViewer,
  PreviewGltf,
} from 'libs/rendering/preview/previewViewer';

import { FileViewerManager } from 'apps/viewer/appManager';
import { ContextManagerProvider } from 'apps/context/hooks';
import { getFormatObject } from 'libs/rendering/utils';

export const PreviewLoader = props => {
  return <PreviewLoaderInner {...props} />;
};

@withNamespaces()
@observer
export class PreviewLoaderInner extends React.Component {
  /* Used for loading files that are not in repositories OR for file previews in general
  Why do we not use this all the time, since its designed to work with contrib files too? */
  constructor(props) {
    super(props);
    this.manager = new FileViewerManager(this, this.props);
  }

  render() {
    const { file, filename, loading } = this.manager;

    if (!(file && filename) || loading) {
      return null;
    }
    const { formatObject } = getFormatObject(file);

    if (formatObject.viewer === 'GltfViewer') {
      return (
        <ContextManagerProvider value={null}>
          <PreviewGltf
            formatObj={formatObject}
            file={file}
            name={filename}
            {...this.props}
          />
        </ContextManagerProvider>
      );
    }
    return (
      <ContextManagerProvider value={null}>
        <PreviewViewer
          formatObj={formatObject}
          file={file}
          name={filename}
          {...this.props}
        />
      </ContextManagerProvider>
    );
  }
}

PreviewLoader.propTypes = {
  fileID: PropTypes.string,
  contributionFileParams: PropTypes.object,
};
